module.exports = __webpack_public_path__ + "static/media/01.457b7d9b.jpg";